// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { TubeService } from 'src/app/modules/tube/services/tube.service';
import { TimelineComponent } from './components/timeline/timeline.component';
import { TubeCardComponent } from './components/tube-card/tube-card.component';
import { TubeComponent } from './components/tube/tube.component';
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule,
    TubeComponent,
    TubeCardComponent,
    TimelineComponent,
  ],
  exports: [TubeComponent],
  providers: [TubeService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TubeModule {}
